export default "__VITE_ASSET__4057518e__"